"use strict"

export const LOGIN = "LOGIN";
export const RESUME_SESSION = "RESUME_SESSION"
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const RECOVER_ACCOUNT = "RECOVER_ACCOUNT"
export const REQUEST_RECOVERY_CODE = "REQUEST_RECOVERY_CODE"
export const RESET_PASSWORD = "RESET_PASSWORD"
export const VALIDATE_RECOVERY_CODE = "VALIDATE_RECOVERY_CODE"
export const SET_ACTIVATION_CODE = "SET_ACTIVATION_CODE"
export const CONFIRM_ACCOUNT = "CONFIRM_ACCOUNT"

export const GET_GRID = "GET_GRID"
export const LOAD_ENTITIES = "LOAD_ENTITIES"
export const DELETE_ENTITIES = "DELETE_ENTITIES"
export const SAVE_ENTITY = "SAVE_ENTITY"
export const NEW_ENTITY = "NEW_ENTITY"
export const GET_ENTITY = "GET_ENTITY"
export const FREE_ENTITIES = "FREE_ENTITIES"
export const GET_LOOKUP_RESULT = "GET_LOOKUP_RESULT"
export const GET_LOOKUP_VALUES = "GET_LOOKUP_VALUES"
export const FREE_LOOKUP = "FREE_LOOKUP"
export const GET_SELECT_ENTITIES = "GET_SELECT_ENTITIES"
export const GET_SELECT_VALUES = "GET_SELECT_VALUES"
export const FREE_SELECT = "FREE_SELECT"

export const SETUP_MENU = "SETUP_MENU"
export const SETUP_CUSTOM_MENU = "SETUP_CUSTOM_MENU"
export const SET_ACTIVE_MENU_ITEM = "SET_ACTIVE_MENU_ITEM"
export const CLEAR_ACTIVE_MENU_ITEM = "CLEAR_ACTIVE_MENU_ITEM"
export const UPDATE_MENU_ROOT = "UPDATE_MENU_ROOT"

export const GET_USER_COVER_IMAGE = "GET_USER_COVER_IMAGE"
export const GET_USER_PROFILE_IMAGE = "GET_USER_PROFILE_IMAGE"
CLEAR_STORES
export const RESET_PASSWORD_CHANGE = "RESET_PASSWORD_CHANGE"
export const RESET_USER_PASSWORD = "RESET_USER_PASSWORD"
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const FREE_SETTINGS_VALUES = "FREE_SETTINGS_VALUES"
export const UPDATE_MULTIVALUE_SETTINGS = "UPDATE_MULTIVALUE_SETTINGS"
export const SET_MULTIVALUE_SETTINGS = "SET_MULTIVALUE_SETTINGS"
export const CHECK_REVISION_ENABLE_STATUS = "CHECK_REVISION_ENABLE_STATUS"

export const SYSTEM_INFORMATIONS = "SYSTEM_INFORMATIONS"

export const GET_ALL_ORGANIZATIONS = "GET_USER_ORGANIZATIONS"
export const CREATE_ORGANIZATION = "CREATE_ORGANIZATION"
export const SELECT_ORGANIZATION = "SELECT_ORGANIZATION"
export const SHOW_ORGANIZATION_SELECTION_DIALOG = "SHOW_ORGANIZATION_SELECTION_DIALOG"
export const HIDE_ORGANIZATION_SELECTION_DIALOG = "HIDE_ORGANIZATION_SELECTION_DIALOG"
export const FIND_FREE_ORGANIZATION_NAME = "FIND_FREE_ORGANIZATION_NAME"

export const FIND_NODES = "FIND_NODES"
export const SET_CONFIGURATION = "SET_CONFIGURATION"
export const REQUEST_STATE_UPDATE = "REQUEST_STATE_UPDATE"
export const SET_STATE = "SET_STATE"

export const SET_SELECTED_TAB = "SET_SELECTED_TAB";
export const CLEAR_TAB_STATE = "CLEAR_TAB_STATE";

export const GET_QUERY = "GET_QUERY"
export const UPDATE_QUERY = "UPDATE_QUERY";
export const UPDATE_FORM_DATA = "UPDATE_FORM_DATA";

export const SHOW_DIALOG = "SHOW_DIALOG"
export const UPDATE_DIALOG = "UPDATE_DIALOG"
export const HIDE_DIALOG = "HIDE_DIALOG"
export const ON_DIALOG_HIDDEN = "ON_DIALOG_HIDDEN"
export const CLEAN_DIALOG_QUEUE = "CLEAN_DIALOG_QUEUE"

export const PRIORITY_LOAD_ITEMS = "PRIORITY_LOADITEMS"
export const PRIORITY_REORDER_ITEMS = "PRIORITY_REORDER_ITEMS"
export const UPDATE_PRIORITIES = "UPDATE_PRIORITIES"
export const CLEAR_PRIORITIES = "CLEAR_PRIORITIES"

export const GET_OPEN_SURVEYS = "GET_OPEN_SURVEYS"
export const GET_USER_SURVEYS = "GET_USER_SURVEYS"
export const GET_SURVEYS_STATS = "GET_SURVEYS_STATS"
export const CREATE_SURVEY = "CREATE_SURVEY"
export const LOAD_SURVEY = "LOAD_SURVEY"
export const CLEAR_SURVEY = "CLEAR_SURVEY"
export const GET_QUESTIONS_TREE = "GET_QUESTIONS_TREE"
export const GET_SURVEY_SCORES = "GET_SURVEY_SCORES"
export const GET_SURVEY_RATINGS = "GET_SURVEY_RATINGS"
export const SET_SURVEY_RATING = "SET_SURVEY_RATING"
export const SET_SURVEY_RATING_NOTES = "SET_SURVEY_RATING_NOTES"
export const GET_SURVEY_USERS = "GET_SURVEY_USERS"
export const CLOSE_SURVEY = "CLOSE_SURVEY"
export const REOPEN_SURVEY = "REOPEN_SURVEY"
export const ADD_RATING_PHOTOS = "ADD_RATING_PHOTOS"
export const DELETE_RATING_PHOTOS = "DELETE_RATING_PHOTOS"

export const GET_RETAILERS = "GET_RETAILERS"
export const GET_RETAILER = "GET_RETAILER"
export const CLEAR_RETAILER = "CLEAR_RETAILER"

export const LOAD_CATEGORY_NODES = "LOAD_CATEGORY_NODES"
export const SELECT_CATEGORY = "SELECT_CATEGORY"
export const DESELECT_CATEGORY = "DESELECT_CATEGORY"
export const SET_SELECTED_CATEGORY_IDS = "SET_SELECTED_CATEGORY_IDS"
export const CLEAR_CATEGORIES = "CLEAR_CATEGORIES"
export const LOAD_CATEGORIES_QUESTIONS_TREE = "LOAD_CATEGORIES_QUESTIONS_TREE"
export const LOAD_SURVEY_TEMPLATE_CATEGORIES = "LOAD_SURVEY_TEMPLATE_CATEGORIES"
export const SELECT_QUESTION_TEMPLATE = "SELECT_QUESTION_TEMPLATE"
export const DESELECT_QUESTION_TEMPLATE = "DESELECT_QUESTION_TEMPLATE"
export const LOAD_ASSOCIATED_QUESTION_TEMPLATE_IDS = "LOAD_ASSOCIATED_QUESTION_TEMPLATE_IDS"
export const ASSOCIATE_QUESTION_TEMPLATE_IDS = "ASSOCIATE_QUESTION_TEMPLATE_IDS"
export const LOAD_SURVEY_TEMPLATE_WEIGHTS = "LOAD_SURVEY_TEMPLATE_WEIGHTS"
export const SET_WEIGHT = "SET_WEIGHT"
export const SET_NOTES = "SET_NOTES"
export const UPDATE_WEIGHTS = "UPDATE_WEIGHTS"
export const LOAD_DEFAULT_SURVEY_NOTES = "LOAD_DEFAULT_SURVEY_NOTES"
export const INIT_PRESENTATION_NOTES = "INIT_PRESENTATION_NOTES"

export const LOAD_STORE_TARGETS = "LOAD_STORE_TARGETS"
export const UPDATE_STORE_TARGETS = "UPDATE_STORE_TARGETS"
export const SET_STORE_TARGET = "SET_STORE_TARGET"
export const LOAD_TARGET_QUESTIONS_TREE = "LOAD_TARGET_QUESTIONS_TREE"
export const LOAD_ALLOWED_STORES = "LOAD_ALLOWED_STORES"
export const CLEAR_STORES = "CLEAR_STORES"
export const GET_STORES_STATS = "GET_STORES_STATS"